import { Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { AccordionProps } from 'src/components/oneCorp/features/MealCredit/common/Accordion/Accordion';
import {
  DisplayBudgetSegmentedControl,
  DisplayBudgetSegmentedControlProps,
} from 'src/components/oneCorp/features/MealCredit/common/formFields/SegmentedControl/DisplayBudgetSegmentedControl';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { AccordionRule } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRule';
import { CheckoutDisplaySettingsRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/CheckoutDisplaySettingsRule/CheckoutDisplaySettingsRuleHeader';
import { withRow } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/withRow';
import {
  CompanyOrderPolicySegmentedControl,
  CompanyOrderPolicySegmentedControlProps,
} from 'src/components/oneCorp/features/MealCredit/common/formFields/SegmentedControl/CompanyOrderPolicySegmentedControl';

export type CheckoutDisplaySettingsRuleProps = Omit<
  AccordionProps,
  'header' | 'body'
>;

const DisplayBudgetWithRow = withRow<DisplayBudgetSegmentedControlProps>(
  DisplayBudgetSegmentedControl
);
const CompanyOrderPolicyWithRow =
  withRow<CompanyOrderPolicySegmentedControlProps>(
    CompanyOrderPolicySegmentedControl
  );

export function CheckoutDisplaySettingsRule({
  ...props
}: CheckoutDisplaySettingsRuleProps): JSX.Element {
  const {
    corpDataValues: { isOrderPolicyVisible = false, corpId },
  } = useMealCreditFormData();

  return (
    <AccordionRule
      {...props}
      header={(isActive): JSX.Element => (
        <CheckoutDisplaySettingsRuleHeader
          isActive={isActive}
          isOrderPolicyVisible={isOrderPolicyVisible}
        />
      )}
      body={(): JSX.Element => (
        <>
          <Stack y={isOrderPolicyVisible ? 'sm' : 'none'}>
            <DisplayBudgetWithRow id="displayBudgets" name="displayBudgets" />
          </Stack>
          {isOrderPolicyVisible && (
            <CompanyOrderPolicyWithRow
              id="orderPolicyAcceptanceRequired"
              name="orderPolicyAcceptanceRequired"
              corpId={corpId}
            />
          )}
        </>
      )}
    />
  );
}
